import { Button, Container, Grid, Stack, styled, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useState } from 'react';
import { BiCloudDownload, BiCloudUpload } from 'react-icons/bi';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
import UploadPolicyTable from './UploadPolicyTable';

function UploadPolicy() {
  const [file, setFile] = useState();
  const [uploadPolicyTable, setUploadPolictTable] = useState(false);
  function handleChange(e) {
    setFile(URL.createObjectURL(e.target.files[0]));
  }
  const Input = styled('input')({
    display: 'none'
  });
  return (
    <Page title="Partner Management System || Policy">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Upload Policy" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Scrollbar>
            <Grid container alignItems="center" spacing={3}>
              <Grid item xs mb={3}>
                <Box variant="Container" className="uploadBox uploadBoxSec">
                  <label htmlFor="contained-button-file" onChange={handleChange}>
                    <Input accept="image/*" id="contained-button-file" multiple type="file" />
                    <Box>
                      <BiCloudUpload className="upladIcon" />
                      <Typography variant="h5">Upload</Typography>
                      <Typography variant="body2">
                        Supported file types: .xls, .xlsx, .csv
                      </Typography>
                    </Box>
                  </label>
                </Box>
              </Grid>
              <Grid xs="auto" item mb={3} sx={{ flexGrow: '1' }}>
                <Button className="mainBtn downloadBtn otherBtn downloadBtnSec" variant="contained">
                  <BiCloudDownload className="downloadIcon" />
                  <Typography variant="subtitle1">Download Template</Typography>
                </Button>
              </Grid>
            </Grid>
            {/* <img src={file} alt="upload Preview" className="uploadPreview" /> */}
            {/* <div className="App">
              <img src={file} alt="upload" />
            </div> */}
            <Box className="" textAlign="right" mb={3}>
              <Button
                variant="contained"
                className="mainBtn"
                onClick={(e) => setUploadPolictTable(true)}
              >
                Submit
              </Button>
            </Box>
            {uploadPolicyTable ? <UploadPolicyTable /> : ' '}
          </Scrollbar>
        </Box>
      </Container>
    </Page>
  );
}
export default UploadPolicy;
